export var componentsLocales = {
  notFound: 'Not found',
  errorNetworkButton: 'Refresh',
  errorNetworkMessage: 'Something went wrong. Check your internet connection and try again'
};